import { render, staticRenderFns } from "./CssLoader.vue?vue&type=template&id=3b31d11d&scoped=true&"
import script from "./CssLoader.vue?vue&type=script&lang=js&"
export * from "./CssLoader.vue?vue&type=script&lang=js&"
import style0 from "./CssLoader.vue?vue&type=style&index=0&id=3b31d11d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31d11d",
  null
  
)

export default component.exports